const DIGITS = '০১২৩৪৫৬৭৮৯';
export const MONTHS = ['জানুয়ারি', 'ফেব্রুয়ারি', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্টেম্বর', 'অক্টোবর', 'নভেম্বর', 'ডিসেম্বর'];

export function bn(v: string | number): string {
  return String(v).replace(/[0-9]/g, (c) => DIGITS[Number(c)]);
}

export function taka(n: number): string {
  return '৳' + bn(Math.round(n).toLocaleString('en-IN'));
}

export function fmtDate(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${bn(d.getDate())} ${MONTHS[d.getMonth()]} ${bn(d.getFullYear())}`;
}

export function fmtTime(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const h = d.getHours();
  const period = h < 5 ? 'রাত' : h < 12 ? 'সকাল' : h < 15 ? 'দুপুর' : h < 18 ? 'বিকাল' : h < 20 ? 'সন্ধ্যা' : 'রাত';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${period} ${bn(h12)}:${bn(String(d.getMinutes()).padStart(2, '0'))}`;
}

export function fmtDateTime(iso?: string): string {
  if (!iso) return '—';
  return `${fmtDate(iso)}, ${fmtTime(iso)}`;
}

export function fmtNumeric(iso?: string, sep = '-'): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return bn(`${dd}${sep}${mm}${sep}${d.getFullYear()}`);
}

export function addDays(iso: string, days: number): string {
  const d = new Date(iso);
  d.setDate(d.getDate() + days);
  return d.toISOString();
}

/** Demo clock: the prototype runs on 15 Oct 2026 using the real time of day. */
export function nowIso(): string {
  const r = new Date();
  return new Date(2026, 9, 15, r.getHours(), r.getMinutes(), r.getSeconds()).toISOString();
}

export function isDemoToday(iso?: string): boolean {
  if (!iso) return false;
  const d = new Date(iso);
  const n = new Date(nowIso());
  return d.getFullYear() === n.getFullYear() && d.getMonth() === n.getMonth() && d.getDate() === n.getDate();
}

export function daysBetween(fromIso: string, toIso: string = nowIso()): number {
  return Math.max(0, Math.floor((new Date(toIso).getTime() - new Date(fromIso).getTime()) / 86400000));
}

export function maskMobile(m: string): string {
  if (m.length < 11) return bn(m);
  return bn(`${m.slice(0, 3)}XX-XXX${m.slice(-3)}`);
}

export function randomDigits(n: number): string {
  let s = '';
  for (let i = 0; i < n; i++) s += Math.floor(Math.random() * 10);
  return s;
}
